import React, { Component } from 'react';
import { Column, cls, Heading } from '../../../packages/components';
import Device from '../../../devices/device';

function TitleSectionEvent(props) {
    const title = props.title || '';
    const className = props.className || null;
    const device = Device.getDevice().getSubplatform();

    return (<Column>
        <Heading className={cls(`event_option_title_section`, `event_option_title_section_${device || ''}`, (className ? className : null))}>
            {title}
        </Heading>
    </Column>);
}

export default TitleSectionEvent;



// WEBPACK FOOTER //
// ./src/components/EventOptions/components/TitleSectionEvent.jsx